import { Command } from '../command-queue/command.interface';
import { ConfigurationManager } from '../configuration-manager/configuration-manager';
import { Configuration } from '../configuration/configuration.model';

export class CallbackCommand implements Command {
  constructor(private callback: (config?: Configuration) => Promise<unknown> | void) {};

  getCtorArgs(): (config?: Configuration) => Promise<unknown> | void {
    return this.callback;
  }

  execute(): Promise<unknown> {
    return this.callback(ConfigurationManager.getConfigState()) || Promise.resolve();
  }
};